<top-banner variant="custom">
    <h2 class="title mb-3">Contractor Site Owner links</h2>
    <button type="button" (click)="openAddNewLinkModal()" class="btn color_blue-btn btn-round"><i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW LINK</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <div class="row">
            <div class="col-md-12">
              <div class="filter-flex-row">
                <div>
                  <label>Contractor Name:</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChangedCompany($event)"></text-filter-box>
                </div>
                <div>
                  <label>Site Owner Name:</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChangedSiteOwner($event)"></text-filter-box>
                </div>
                <div *ngIf="isFilterLoading" class="small-spinner">
                  <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                </div>
              </div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table
                  [value]="contractorSiteOwnerLinks"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Contractor Id</th>
                    <th [pSortableColumn]="'contractor'">Contractor
                      <p-sortIcon [field]="'contractor'"></p-sortIcon>
                    </th>
                    <th>Site Owner Id</th>
                    <th [pSortableColumn]="'siteOwner'">Site Owner
                      <p-sortIcon [field]="'siteOwner'"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-contractorSiteOwnerLink>
                  <tr>
                    <td>{{ contractorSiteOwnerLink.maintenanceId }}</td>
                    <td>{{ contractorSiteOwnerLink.maintenanceName }}</td>
                    <td>{{ contractorSiteOwnerLink.siteOwnerUser.id }}</td>
                    <td>{{ contractorSiteOwnerLink.siteOwnerUser.name }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">No contractors site owner links found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
        </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
